import moment from 'moment'
const vFilter = {
  // 时间格式化
  dateFormat: function (time) {
    time[1] = time[1] - 1
    const timePre = moment(time).format('YYYY-MM-DD HH:mm:ss')
    return timePre
  },
  // 时间格式化
  timeFormat: function (time) {
    const timePre = moment(time).format('YYYY-MM-DD HH:mm:ss')
    return timePre
  },
  transferText: function (state) {
    switch (state) {
      case 1:
        return '正在上传'
      case 2:
        return '暂停'
      case 3:
        return '上传失败'
      case 4:
        return '上传成功'
      default:
        return ''
    }
  },
  transferSdkText: function (state) {
    switch (state) {
      case 0:
        return '正在上传'
      case 1:
        return '正在上传'
      case 2:
        return '上传失败'
      case 3:
        return '上传成功'
      case 4:
        return '暂停'
      default:
        return ''
    }
  },
  transferSpeed: (speed) => {
    let units = 'b/s' // 单位名称

    if (speed / 1024 > 1) {
      speed = speed / 1024
      units = 'k/s'
    }

    if (speed / 1024 > 1) {
      speed = speed / 1024
      units = 'M/s'
    }

    speed = speed.toFixed(1)

    return speed + ' ' + units
  },
  transferStatus: function (state) {
    switch (state) {
      case 1:
        return 'false'
      case 2:
        return 'false'
      case 3:
        return 'exception'
      case 4:
        return 'success'
      default:
        return 'false'
    }
  },
  transferFileSize: function (limit) {
    let size = ''
    if (limit < 0.1 * 1024) { // 如果小于0.1KB转化成B
      size = limit.toFixed(2) + 'B'
    } else if (limit < 0.1 * 1024 * 1024) { // 如果小于0.1MB转化成KB
      size = (limit / 1024).toFixed(2) + 'KB'
    } else if (limit < 0.1 * 1024 * 1024 * 1024) { // 如果小于0.1GB转化成MB
      size = (limit / (1024 * 1024)).toFixed(2) + 'MB'
    } else { // 其他转化成GB
      size = (limit / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
    }

    const sizestr = size + ''
    const len = sizestr.indexOf('.')
    const dec = sizestr.substr(len + 1, 2)
    if (dec == '00') { // 当小数点后为00时 去掉小数部分
      return sizestr.substring(0, len) + sizestr.substr(len + 3, 2)
    }
    return sizestr
  },
  dealDataW: function (val) {
    if (val >= 10000) {
      val = (val / 10000).toFixed(1) + '万'
      return val
    } else if (val >= 0 && val < 10000) {
      return val
    } else {
      return ''
    }
  },
  vodAuditState: function (val) {
    if (val == 'AUDIT_ING') {
      return '待初审'
    } else if (val == 'AUDIT_NO_PASS') {
      return '初审驳回'
    } else if (val == 'RE_AUDIT_ING') {
      return '待复审'
    } else if (val == 'RE_AUDIT_PASS') {
      return ' 复审通过'
    } else if (val == 'RE_AUDIT_NO_PASS') {
      return '复审驳回'
    }
  }
}
export default vFilter
